// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".news-item{background-color:#fff;color:#000;border-radius:6px;margin-top:20px}.news-item__container{position:relative;padding:20px}.news-item__content{margin:10px 0}.news-item__title{font-weight:700}.news-item__publishdate{font-size:smaller;color:#777}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
